import { trackEvent } from 'modules/analytics';

const trackSwitchRiversideClicked = () => {
  trackEvent(
    null,
    {
      eventCategory: 'riverside_switch_modal',
      eventAction: 'switch',
      eventLabel: 'riverside_modal_switch',
    },
    // eslint-disable-next-line no-undef
    { providers: [ga] }
  );
};

const trackSwitchCloseModalClick = () => {
  trackEvent(
    null,
    {
      eventCategory: 'riverside_switch_modal',
      eventAction: 'nevermind',
      eventLabel: 'riverside_modal_nevermind',
    },
    // eslint-disable-next-line no-undef
    { providers: [ga] }
  );
};

const trackRiversideSwitchSignupClicked = () => {
  trackEvent(
    null,
    {
      eventCategory: 'riverside_switch_signup_modal',
      eventAction: 'sign_up',
      eventLabel: 'riverside_switch_signup_modal',
    },
    // eslint-disable-next-line no-undef
    { providers: [ga] }
  );
};

const trackRiversideSwitchImportClicked = () => {
  trackEvent(
    null,
    {
      eventCategory: 'riverside_switch_signup_modal',
      eventAction: 'import',
      eventLabel: 'riverside_import_signup_modal',
    },
    // eslint-disable-next-line no-undef
    { providers: [ga] }
  );
};

export {
  trackSwitchRiversideClicked,
  trackSwitchCloseModalClick,
  trackRiversideSwitchSignupClicked,
  trackRiversideSwitchImportClicked,
};
